function initDropDown() {
    try {
        // Функция для скрытия всех дропдаунов, кроме текущего
        function hiddenDropDown(exceptDropdown) {
            if (document.querySelectorAll(".dropdown__button") != null) {
                const dropDownBtn = document.querySelectorAll(".dropdown__button");
                const dropDownList = document.querySelectorAll(".dropdown__list");

                dropDownBtn.forEach((item) => {
                    // Скрываем все, кроме текущего
                    if (exceptDropdown && exceptDropdown.contains(item)) {
                        return; // Пропускаем текущий дропдаун
                    }
                    item.classList.remove("dropdown__button--active");
                });

                dropDownList.forEach((item) => {
                    // Скрываем все, кроме текущего
                    if (exceptDropdown && exceptDropdown.contains(item)) {
                        return; // Пропускаем текущий дропдаун
                    }
                    item.classList.remove("dropdown__list--visible");
                });
            }
        }

        // Функция для удаления класса активности у всех элементов в конкретном дропдауне
        function removeClasses(dropdown) {
            if (dropdown) {
                const listItems = dropdown.querySelectorAll(".dropdown__list-item");
                listItems.forEach((item) => {
                    item.classList.remove("dropdown__list-item--active");
                });
            }
        }

        document.addEventListener('click', (event) => {
            if (event.target.closest(".dropdown")) {
                const currentDropdown = event.target.closest(".dropdown");

                // Скрываем все дропдауны, кроме текущего
                hiddenDropDown(currentDropdown);

                if (event.target.closest(".dropdown__button")) {
                    let dropDownBtn = currentDropdown.querySelector(".dropdown__button");
                    let dropDownList = currentDropdown.querySelector(".dropdown__list");

                    // Переключаем класс активности только для текущего дропдауна
                    dropDownBtn.classList.toggle("dropdown__button--active");
                    dropDownList.classList.toggle("dropdown__list--visible");
                }

                if (event.target.closest(".dropdown__list-item")) {
                    let textBtn = currentDropdown.querySelector(".dropdown__button-text");
                    let pathList = event.target.closest(".dropdown__list-item");

                    // Удаляем классы активности только внутри текущего дропдауна
                    removeClasses(currentDropdown);

                    // Добавляем класс активности выбранному элементу
                    pathList.classList.add('dropdown__list-item--active');

                    // Обновляем текст кнопки
                    let listText = pathList.querySelector(".dropdown__list-item-text");
                    textBtn.innerHTML = listText.textContent;

                    // Сохраняем значение в скрытый input, если он есть
                    const hiddenInput = currentDropdown.querySelector('.dropdown__input-hidden');
                    if (hiddenInput && pathList.dataset.value) {
                        hiddenInput.value = pathList.dataset.value;
                    }

                    // Обновляем изображение, если оно есть
                    let imageBtn = currentDropdown.querySelector(".dropdown__img");
                    if (imageBtn) {
                        let listImage = pathList.querySelector(".dropdown__img");
                        if (listImage) {
                            imageBtn.setAttribute('src', listImage.getAttribute('src'));
                        }
                    }

                    // Делаем кнопку активной
                    currentDropdown.querySelector(".dropdown__button").classList.add("dropdown__button--active");

                    // Скрываем список
                    currentDropdown.querySelector(".dropdown__list").classList.remove("dropdown__list--visible");
                }
            } else {
                // Если клик был вне дропдауна, скрываем все дропдауны
                hiddenDropDown();
            }
        });

        // При инициализации восстанавливаем выбранные значения для каждого дропдауна
        document.querySelectorAll('.dropdown').forEach((dropdown) => {
            const activeItem = dropdown.querySelector('.dropdown__list-item--active');
            if (activeItem) {
                const buttonText = dropdown.querySelector('.dropdown__button-text');
                const listText = activeItem.querySelector('.dropdown__list-item-text');

                if (buttonText && listText) {
                    buttonText.innerHTML = listText.textContent;
                }

                // Делаем кнопку активной
                dropdown.querySelector('.dropdown__button').classList.add('dropdown__button--active');

                // Обновляем скрытый input, если он есть
                const hiddenInput = dropdown.querySelector('.dropdown__input-hidden');
                if (hiddenInput && activeItem.dataset.value) {
                    hiddenInput.value = activeItem.dataset.value;
                }

                // Обновляем изображение, если оно есть
                const imageBtn = dropdown.querySelector('.dropdown__img');
                const listImage = activeItem.querySelector('.dropdown__img');

                if (imageBtn && listImage) {
                    imageBtn.setAttribute('src', listImage.getAttribute('src'));
                }
            }
        });
    } catch (error) {
        console.error('Error in initDropDown:', error);
    }
}